import { EventEmitter, Injectable, Output } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { PdfViewerModalComponent } from 'src/app/shared/modals/pdf-viewer-modal/pdf-viewer-modal.component';

@Injectable({
  providedIn: 'root'
})
export class PdfViewerModalService {

  @Output() modelChanged = new EventEmitter<any>(); 

  constructor(  private modalService: NgbModal) { }

  openModal(blob: any, documentName?: string) {
    var modalRef!: NgbModalRef;

    modalRef = this.modalService.open( PdfViewerModalComponent, { size: 'xl', centered: true, backdrop: 'static', keyboard: false });
    modalRef.componentInstance.blob = blob;
    modalRef.componentInstance.documentName = documentName;
    modalRef.result.then(() => {
      this.modelChanged.emit(true);
    });
  }
}